<template>
    <div class="common-title-box" :style="getStyle">
        <ul class="tag-list">
            <li
                :class="[{ active: curTag === item.key }]"
                v-for="item in realList"
                :key="item.key"
                @click="changeTag(item.key)"
            >
                {{ item.name }}
            </li>
        </ul>
        <slot></slot>
        <div v-if="props.showMore">
            <a class="more" @click="goMore" href="javascript:;">{{ moreText }}&nbsp;></a>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, computed, PropType } from 'vue';

type CommonTitleType = {
    key: string;
    name: string;
    checked?: boolean;
};

const props = defineProps({
    showMore: {
        type: Boolean,
        default: true,
    },
    tagList: {
        type: Array as PropType<Array<CommonTitleType>>,
        default: () => {
            return [];
        },
    },
    titleSize: {
        type: String,
        default: '18px',
    },
    hoverColor: {
        type: String,
        default: '#2164c9',
    },
    titleColor: {
        type: String,
        default: '#333',
    },
    titleFontWeight: {
        type: String,
        default: 'bold',
    },
    moreText: {
        type: String,
        default: '更多',
    },
});

const realList = computed(() => {
    return props.tagList.map(item => {
        return {
            ...item,
            checked: item.checked || false,
        };
    });
});

const emit = defineEmits(['goMore', 'changeTag']);

const curTag = ref<string>(realList.value[0]?.key || '');

const getStyle = computed(() => {
    return `
    --title-size: ${props.titleSize};
    --hover-color: ${props.hoverColor};
    --title-color: ${props.titleColor};
    --title-font-weight: ${props.titleFontWeight};
    `;
});

const goMore = () => {
    emit('goMore');
};

const changeTag = key => {
    curTag.value = key;
    emit('changeTag', curTag.value);
};
</script>

<style lang="scss" scoped>
.common-title-box {
    margin-top: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    border-bottom: 1px solid #d3dcd1;

    .more {
        font-size: 14px;
        color: var(--hover-color);
        line-height: 14px;
        display: block;
        user-select: none;
    }

    .tag-list {
        flex: 1;
        height: 100%;
        display: flex;

        li {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            cursor: pointer;
            user-select: none;
            font-size: var(--title-size);
            font-weight: bold;
            transition: all 0.1s;
            color: var(--title-color);

            &:not(:first-child) {
                margin-left: 20px;
            }

            &::after {
                display: none;
                position: absolute;
                bottom: 0;
                content: '';
                width: 100%;
                height: 3px;
                background-color: var(--hover-color);
            }

            &.active {
                color: var(--hover-color);

                &::after {
                    display: block;
                }
            }
        }
    }
}
</style>
